// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"583":"d116f6b8","710":"ccd26259","845":"2ebcc20b"}[chunkId] + ".chunk.js";
};